import React from 'react';

const Cross = () => {

  return (
    <>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" x="0px" y="0px"><path d="M56.63,50l9.52-9.52a4.69,4.69,0,1,0-6.63-6.63L50,43.37l-9.52-9.52a4.69,4.69,0,1,0-6.63,6.63L43.37,50l-9.52,9.52a4.69,4.69,0,1,0,6.63,6.63L50,56.63l9.52,9.52a4.69,4.69,0,1,0,6.63-6.63Z"/></svg>
    </>
  );
};

export default Cross;
